// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productPrimaryImageStyles } from "@insite/content-library/Components/ProductPrimaryImage";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

productPrimaryImageStyles.hiddenWrapper = {
    css: css`
        position: absolute;
        visibility: hidden;
        height: 0;
        width: 0;
    `,
};

productPrimaryImageStyles.image = {
    css: css`
        cursor: pointer;
        background: none;

        .LazyImage-Placeholder {
            display: none;
        }

        .LazyImage-ErrorMessage {
            min-width: 100%;
            padding: 20px 40px;
            background-color: ${getColor("common.accent")};
        }
    `,
};

productPrimaryImageStyles.spinner = {
    color: "primary.main",
    css: css`
        margin: auto;
    `,
};